import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency, pythonApiIp } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants.js'


export class DepositConfirmation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalOrderAmount: '',
            depositAmount: '',
            balance: '',
            phone: this.props.order.phone,
            loading: false
        }
    }

    sendConfirmation = () => {

        this.setState({ loading: true })

        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        // let orderUpdates = {
        //     depositRequested: depValue,
        //     depositRequestedDateNum: d.getTime(),
        //     depositRequestedTime: now,
        //     depositAmount: this.state.depositAmount
        // }
        // FbUtils.updateOrder(getOrderKey(this.props.order) , orderUpdates);

        // let updateText = "deposit:"+toCurrency(this.state.depositAmount)+" -"+this.props.user.email.substring(0,10);

        // FbUtils.insertUpdateText(getOrderKey(this.props.order), updateText, this.props.user.email);

        // if (this.props.searchNow) {
        //     console.log("upx771001 updateCommentFormSubmit searchnow is true call refresh after time out.");

        //     setTimeout(this.props.setRefreshToTrue, 5000);
        //     setTimeout(this.props.setRefreshToFalse, 10000);
        // }

        
        axios.post(pythonApiIp + 'sendDepositMadeSms', {
            apiKey: "asdf@asdfasdf",
            order_num: this.props.order.order_num,
            fborderkey: getOrderKey(this.props.order),
            phone: this.state.phone,
            amount: parseInt(this.state.depositAmount),
            balance: parseInt(this.state.totalOrderAmount - this.state.depositAmount),
            enteredBy: this.props.user.email,
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(response.data);

                if (response.data.result) {
                    this.setState({ loading: false })
                    console.log(response);

                    if (response.data.result) {
                        console.log("sms sent");
                        alert(response.data.message)

                        let orderUpdates = {
                            depositRequested: "paid",
                            depositRequestedDateNum: d.getTime(),
                            depositRequestedTime: now,
                            depositAmount: this.state.depositAmount
                        }
                        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);

                        let updateText = "deposit:" + toCurrency(this.state.depositAmount) + " -" + this.props.user.email.substring(0, 10);
                        // let updateText = "deposit:"+this.state.depositAmount+"- "+this.props.user.email.substring(0,10);
                        FbUtils.insertUpdateText(getOrderKey(this.props.order), updateText, this.props.user.email);

                        this.setState({
                            totalOrderAmount: '',
                            depositAmount: '',
                            balance: '',
                        })
                    }
                } else {
                    console.log("FAILED");
                    alert("FAILED TO SET COUPON:" + response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({ loading: false })
            });

    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    render() {

        const payButton = this.state.depositAmount !== '' && this.state.phone !== ''
            ? <Button color='green' onClick={this.setDepPaid}> SEND CONFIRMATION </Button>
            : ''

           
        const depositUI =  this.props.order.depositRequested === "paid"
        ? <h5> DEPOSIT PAID - {this.props.order.depositAmount} - {this.props.order.depositRequestedTime} </h5>
        
        :<Form onSubmit={this.sendConfirmation}>

            <label>Order Amount:{toCurrency(this.state.totalOrderAmount)}</label>
            <Form.Input
                fluid
                icon='money'
                iconPosition='left'
                placeholder='Total Order Amount'
                type='number'
                name="totalOrderAmount"
                value={this.state.totalOrderAmount}
                onChange={this.handleTextInputChange}
            />

            <label>Deposit:{toCurrency(this.state.depositAmount)}</label>
            <Form.Input
                fluid
                icon='money'
                iconPosition='left'
                placeholder='Deposit Amount'
                type='number'
                name="depositAmount"
                value={this.state.depositAmount}
                onChange={this.handleTextInputChange}
            />
            <label>Balance:{toCurrency(this.state.balance)}</label>
            <Form.Input
                fluid
                icon='money'
                iconPosition='left'
                placeholder='Balance'
                type='number'
                name="balance"
                value={this.state.totalOrderAmount - this.state.depositAmount}
                onChange={this.handleTextInputChange}
            />
            <Form.Input
                fluid
                icon='phone'
                iconPosition='left'
                placeholder='Phone'
                type='number'
                name="phone"
                value={this.state.phone}
                onChange={this.handleTextInputChange}
            />
            {payButton}
        </Form>
        
        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Divider horizontal>{'DEPOSIT INFO'}</Divider>

                {depositUI}



            </div>
        )
    }
}

export default DepositConfirmation;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Deposits/DepositConfirmation.js